import { ShieldCheckIcon, AlertCircleIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import Button from '@/components/form/Button';

interface AgeVerificationBannerProps {
  isVerified: boolean;
}

export default function AgeVerificationBanner({ isVerified }: AgeVerificationBannerProps) {
  if (isVerified) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <ShieldCheckIcon className="h-5 w-5 text-green-500" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-green-800">Age Verified</h3>
            <div className="mt-1 text-sm text-green-700">
              <p>Your age has been verified. You can participate in CashSNAPs and withdraw earnings.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertCircleIcon className="h-5 w-5 text-yellow-500" />
        </div>
        <div className="ml-3 flex-1">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-sm font-medium text-yellow-800">Age Verification Required</h3>
              <div className="mt-1 text-sm text-yellow-700">
                <p>You must verify your age to participate in CashSNAPs and withdraw earnings.</p>
              </div>
            </div>
            <Button
              variant="primary"
              size="sm"
              className="bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500 ml-4"
            >
              <Link to="/verify-age">
                Verify Age
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}